<template>
  <div class="act-apl">
    <m-loading :loading="pageLoading"></m-loading>
    <div class="form-ipt">
      <div class="input">
        <!-- 头像 -->
        <van-field label-class="affixs-label">
          <template #label>
            <span class="custom-title" error-message-align="right" :error-message="validate.fieldMsg.head">学生头像</span>
            <span class="custom-tit">(jpg/png格式最多一张，每张不超过3M)</span>
          </template>
        </van-field>
        <div class="baby-head">
          <van-uploader :before-delete="headBeforeDel" v-model="head" :max-count="1" :before-read="uploadBeforeRead"/>
        </div>
        <template v-if="formData.imgsArr&&formData.imgsArr.length>0">
          <div v-for="(time,index) in formData.imgsArr" :key="index">
            <van-field input-align="right" label-class="affixs-label" label="作品文件" required error-message-align="right" :error-message="validate.fieldMsg.imgs">
              <template #label>
                <span class="custom-title">作品{{time.fileType==1?'图片':time.fileType==2?'音频':time.fileType==3?'视频':time.fileType==4?'文档':''}}文件</span>
                <div class="custom-tit">
                  <span v-if="time.formatInfo">{{ time.formatInfo }}格式</span>
                </div>
              </template>
            </van-field>
            <div class="photo-upload">
              <van-uploader :accept="time.formatInfo" v-model="time.photo_file_list" :max-count="1" 
              :before-read="(file)=>photoBeforeRead(file,index)"
              />
            </div>
          </div>
        </template>
        <!-- <van-field
          input-align="right"
          label-class="affixs-label"
          label="作品文件"
          required
          error-message-align="right"
          :error-message="validate.fieldMsg.imgs"
        >
          <template #label>
            <span class="custom-title">作品文件</span>
            <span class="custom-tit">(jpg/png格式最多1张，每张不超过10M)</span>
          </template>
        </van-field>
        <div class="photo-upload">
          <van-uploader
            v-model="photo_file_list"
            :max-count="1"
            :before-read="photoBeforeRead"
          />
        </div> -->

        <van-field
          v-if="sourceFileMust"
          input-align="right"
          label-class="affixs-label"
          label="源文件附件"
          :required="sourceFileMust"
          error-message-align="right"
          :error-message="validate.fieldMsg.sourceFile"
        >
          <template #label>
            <span class="custom-title">源文件附件</span>
            <span class="custom-tit">(PSD/AI/CDR等格式，不超过50M)</span>
          </template>
        </van-field>
        <div class="file-upload" v-if="sourceFileMust">
          <van-uploader
            v-model="photo_affix_list"
            :max-count="1"
            :before-read="affixBeforeRead"
          >
            <template #preview-cover>
              <div class="preview-cover van-ellipsis">
                {{ photo_affix_list[0].name }}
              </div>
            </template>
          </van-uploader>
        </div>
      </div>
      <div class="submit">
        <van-button
          size="large"
          @click="submitFn"
          color="linear-gradient(to right, #5DD682, #5AFF8E)"
          >提交</van-button
        >
      </div>
    </div>
    <Crop
      :popup.sync="compressShow"
      :img="compressImg"
      @close="cancelUpload"
      @getImageData="uploadHead"
    />
  </div>
</template>

<script>
import { validate } from "@/utils/mixin/validate";
import { getCurrentActivityMajor } from "@/utils/api/home";
import {
  uploadImg,
  uploadFile,
  getWorksDetails,
  replenishWorks
} from "@/utils/api/user";
import Crop from "@/components/pub/CompressCrop.vue";
import { checkUploadFile } from "@/utils/tool";
export default {
  mixins: [validate],
  components: {
    Crop
    // "sign-title": SignTitle
  },
  data() {
    return {
      pageLoading: true,
      // 显示选择专业
      majorShow: false,
      // 专业列表
      majorColumns: [],
      // 显示选择组别
      groupShow: false,
      // 组别名称
      group: null,
      // 组别列表
      groupColumns: [],
      // 头像
      head: [],
      // 作品文件
      photo_file_list: [],
      // 作品源文件
      photo_affix_list: [],

      // 需要提交的表单信息
      formData: {
        head: null,
        phone: null,
        imgs: null,
        sourceFile: null,
        imgsArr:[],
      },
      // 作品id
      worksId: null,
      // 需要源文件
      sourceFileMust: false,
      compressShow: false,
      compressImg: ""
    };
  },
  mounted() {
    this.formData.province = this.$store.state.province;
    this.getPageSelectInfo();
    const mode = parseInt(this.$route.query.mode);
    const id = this.$route.query.id;
    this.worksId = id;
    this.mode = mode;
    if (this.mode) {
      this.getWork();
    }
  },
  methods: {
    // 获取页面信息
    async getPageSelectInfo() {

    },
    // 补充数据时调用
    async getWork() {
      const res = await getWorksDetails(this.worksId);
      if (res.success) {
        // 获取专业 组别
        let MajorRes = await getCurrentActivityMajor({
          activityId: res.data.activityId,
          channelId:res.data.channelId
        });
        console.log('MajorRes =', MajorRes)
        if (MajorRes.success) {
          if(res.data.institutionId){
            this.majorColumns = MajorRes.data.institutionEnrol.map((e) => {
              return {
                fileTypeList:e.fileTypeList,
                text: e.majorName,
                value: e.majorId,
                gruop: e.childGroup,
                sourceFileMust: e.typeId == 1
              };
            });
          }else if(res.data.mainBodyType == 1){
            this.majorColumns = MajorRes.data.personalEnroll.map((e) => {
              return {
                fileTypeList:e.fileTypeList,
                text: e.majorName,
                value: e.majorId,
                gruop: e.childGroup,
                sourceFileMust: e.typeId == 1
              };
            });
          }else{
            this.majorColumns = MajorRes.data.groupEnroll.map((e) => {
              return {
                fileTypeList:e.fileTypeList,
                text: e.majorName,
                value: e.majorId,
                gruop: e.childGroup,
                sourceFileMust: e.typeId == 1
              };
            });
          }
        }
        // 专业组别
        const maj = this.majorColumns.filter((e) => {
          return e.value === res.data.majorId;
        })[0];
        this.formData.imgsArr = []
        for(let k in maj.fileTypeList){
          let kType = maj.fileTypeList[k];
          let formatInfo = '';
          if(kType == 1){
            formatInfo = 'image/jpeg,image/png,image/jpg';
          }else if(kType==2){
            formatInfo = '.mp3,.wav,.ogg,.mpeg';
          }else if(kType==3){
            formatInfo = '.mp4,.avi.mov';
          }else if(kType==4){
            formatInfo = '.doc,.docx';
          }
          this.formData.imgsArr.push({
            fileName:'',
            fileUrl:'',
            url:'',
            fileType:kType,
            formatInfo:formatInfo,
            photo_file_list:[]
          })
        }
        this.formData.majorVal = maj.value;
        this.sourceFileMust = maj.sourceFileMust;
        this.pageLoading = false;
      }
    },
    // 删除已经上传的头像
    headBeforeDel() {
      this.formData.head = null;
      return true;
    },
    // 头像上传前预处理
    uploadBeforeRead(file) {
      this.compressImg = URL.createObjectURL(file);
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "图片编辑...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      this.compressShow = true;
    },
    cancelUpload() {
      this.compressShow = false;
      this.head = [];
    },
    // 上传头像
    async uploadHead(file) {
      const pass = checkUploadFile({ file, size: 3 }, (err) => {
        this.$root.$toast.fail(err);
        this.head = [
          {
            url: "",
            message: "图片大于3m，请重新选择图片。",
            status: "failed",
            name: file.name
          }
        ];
      });
      if (!pass) {
        return;
      }
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      this.$root.$toast.loading({
        message: "上传图片中……",
        duration: 0
      });
      upimgobj.append("file", file);
      const { data: url, success } = await uploadImg(upimgobj);
      if (success) {
        this.head = [
          {
            url,
            status: "done",
            name: file.name
          }
        ];
        this.formData.head = url;
      } else {
        this.head = [
          {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          }
        ];
      }
      this.$forceUpdate();
      this.$root.$toast.clear();
    },

    // 图片上传
    photoBeforeRead(file,index) {
      let imgsArr = this.formData.imgsArr[index]
      console.log(imgsArr)
      const pass = checkUploadFile(
        { file, size: 100, type: imgsArr.fileType, typestr: imgsArr.formatInfo },
        (err) => {
          this.$root.$toast.fail(err);
        }
      );
      if (!pass) {
        return false;
      }
      this.formData.imgsArr[index].photo_file_list = [{
        message:"上传中...",
        status:'uploading',
      }]
      this.formData.imgsArr[index].url = '';
      let upimgobj = new FormData();
      upimgobj.append("file", file);
      uploadFile(upimgobj).then(({ success, data}) => {
        if (success) {
          this.formData.imgsArr[index].photo_file_list = [{
            message:"上传中...",
            status:"done",
            url:data.fileUrl,
          }]
          return success;
        } else {
          this.formData.imgsArr[index].photo_file_list = [{
            message:"上传失败，请重新上传",
            status:"failed",
            url:'',
          }]
          return success;
        }
      });
    },
    // 源文件上传
    affixBeforeRead(file) {
      const fileName = file.name;
      const pass = checkUploadFile(
        { file, size: 100, type: 1, typestr: -1 },
        (err) => {
          this.$root.$toast.fail(err);
        }
      );
      if (!pass) {
        return false;
      }
      this.photo_affix_list = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: fileName
        }
      ];
      let upfileobj = new FormData();
      upfileobj.append("file", file);
      uploadFile(upfileobj).then(({ success, data }) => {
        if (success) {
          this.photo_affix_list = [
            {
			        url: data.fileUrl,
              name: fileName,
              status: "done"
            }
          ];
          this.formData.sourceFile = data.fileUrl;
          return success;
        } else {
          this.photo_affix_list = [
            {
              url: "",
              message: "上传失败，请重新上传",
              status: "failed"
            }
          ];
          return success;
        }
      });
    },
    // 提交信息
    async submitFn() {
      for(let k in this.formData.imgsArr){
        let imgsArr = this.formData.imgsArr[k]
        if(imgsArr.photo_file_list.length<1){
          this.$root.$toast.fail("请上传"+imgsArr.formatInfo+'格式文件');
          return
        }
        if(imgsArr.photo_file_list[0].status=="uploading"){
          this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
          return;
        }
      }
      let imgs = [];
      this.formData.imgsArr.map(K=>{
        if(K.photo_file_list[0].url){
          imgs.push(K.photo_file_list[0].url)
        }
      })
        this.formData.imgs = imgs
      if (this.sourceFileMust && !this.formData.sourceFile) {
        this.$root.$toast.fail("请补充源文件");
        return;
      }
      if (
        (this.photo_affix_list.length > 0 && this.photo_affix_list[0].status === "uploading") ||
        (this.head.length > 0 && this.head[0].status === "uploading")
      ) {
        this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
        return;
      }
      replenishWorks({
        id: this.worksId,
        imgs: this.formData.imgs,
        sourceFile: this.formData.sourceFile,
        userImg: this.formData.head
      }).then((res) => {
        if (res.success) {
          this.$toast.success("补充成功");
          this.$router.go(-1);
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.act-apl {
  min-height: 100vh;
  width: 100%;
  max-width: 10rem;
  // padding: 0 20px;
  background-color: #f9f9f9;
  .form-ipt {
    padding-bottom: 60px;
    .input {
      .van-cell {
        &::after {
          border: none;
        }
      }
      // padding: 0 20px;
      .van-cell__title {
        text-align: left;
      }
      .photo-upload,
      .file-upload {
        padding: 0 10px;
        background-color: #fff;
      }
    }
  }
}
</style>
<style lang="scss">
@import "@/assets/css/customer.scss";
.act-apl {
  text-align: left;
  .affixs-label {
    width: unset;
    & + .van-field__value {
      display: none;
    }
  }
  .input {
    .van-uploader {
      @include from-upload-style;
    }
  }
  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }
  .submit {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
  .custom-tit {
    font-size: 12px;
    color: #cccccc;
  }
  .baby-head {
    text-align: left;
    background-color: #fff;
    .van-uploader {
      @include from-upload-style;
    }
  }
}
</style>
